import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';

import { store } from '@redux/storeConfig/store';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';

export const baseUrl = '/notification';

interface NotificationRequest {
  operatorId?: number;
  organizationId?: number;
  divisionId?: number;
  subdivisionId?: number;
  email?: string;
  consoleId?: number;
  notificationTypeId: string;
  eventId?: number;
  isWebService?: boolean;
}

interface ConsoleRequest {
  organizationId?: number;
}

interface NotificationSaveRequest {
  consoleId?: number;
  notificationTypeId: string;
  events?: string;
  units?: string;
  emails?: string;
  urlWebHook?: string;
  idTrackerUser?: number;
}

interface notification {
  unitId: number;
  eventId: number;
  orderId: number;
}

interface NotificationDeleteRequest {
  notifications: notification[];
  notificationsLength: number;
}

interface SystemNotificationGetRequest {
  entityTypeId?: number;
  operatorId?: number;
  organizationId?: number;
}

interface SystemNotificationsMarkAsReadRequest {
  notificationIds: string;
}

interface UserNotificationsMarkAsReadRequest {
  notificationIds: string;
}

interface UserNotificationsMarkAsForwardRequest {
  notificationIds: string;
}

interface SystemNotificationSaveRequest {
  systemNotificationId: number | undefined;
  messageType: number;
  messageTitle: string;
  message: string;
  startDate: string;
  endDate: string;
  entityTypeId: number;
  operatorId: number | undefined;
  organizationId: number | undefined;
  roleId: number | undefined;
  userName: string | undefined;
  mobileOperatorId: number | undefined;
  showToast: boolean;
  toastTime: number | undefined;
  isWebtrackNotification: boolean | undefined;
}

export const getNotificationsListService = (
  request: NotificationRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getNotificationList`, request);
};

export const getConsoleListService = (request: ConsoleRequest, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'console.console',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getConsoleList`, request);
};

export const getWebServiceListService = (request: ConsoleRequest, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.webService',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getWebServiceList`, request);
};
export const getTrackerUsersListService = (request: ConsoleRequest, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.tracker',
    action: 'Get',
    genderType: 'PluralMale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getTrackerUsersList`, request);
};

export const saveNotifications = (
  request: NotificationSaveRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Create',
    genderType: 'SingularFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/saveNotifications`, request);
};

export const deleteNotifications = (
  request: NotificationDeleteRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Delete',
    genderType: 'SingularFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/deleteNotifications`, request);
};

export const getSystemNotificationsListService = (
  request: SystemNotificationGetRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getSystemNotificationsList`, request);
};

export const getUserNotificationsListService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getUserSystemNotifications`, request);
};

export const markSystemNotificationsAsReadService = (
  request: SystemNotificationsMarkAsReadRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/markAsReadSystemNotifications`, request);
};

export const markUserNotificationsAsReadService = (
  request: UserNotificationsMarkAsReadRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/markAsReadUserNotifications`, request);
};

export const markUserNotificationsAsForwardService = (
  request: UserNotificationsMarkAsForwardRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    action: 'Get',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/markAsForwardUserNotifications`, request);
};

export const saveUserNotificationService = (
  request: SystemNotificationSaveRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    name: `${request.messageTitle}`,
    action: 'Create',
    genderType: 'SingularFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/saveSystemNotification`, request);
};

export const deleteUserNotificationService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'notifications.notification',
    name: `${request.messageTitle}`,
    action: 'Delete',
    genderType: 'PluralFemale'
  });

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/deleteSystemNotification`, request);
};
